import React from "react";
import { EpgEventDetailOverride } from "../../../../../models/epg/Models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";

type MultiTextareaFieldProps<K extends keyof EpgEventDetailOverride> = {
    label: string;
    items: string[];
    isEditMode: boolean;
    fieldName: K;
    updateField: <K extends keyof EpgEventDetailOverride>(key: K, value: EpgEventDetailOverride[K]) => void;
}

const MultiTextareaField = ({ label, items, isEditMode, fieldName, updateField }: MultiTextareaFieldProps<keyof EpgEventDetailOverride>) => {
    const addItem = () => {
        const tempItems = items ? items : [];
        const newItems =  tempItems.some(item => item.length === 0) ? items : [ ...items, "" ];

        updateField(fieldName, newItems);
    };

    const deleteItem = (index: number) => {
        const newItems = [ ...items ];
        newItems.splice(index, 1);
        updateField(fieldName, newItems);
    };

    return (
        <>
            <div className = {`flex flex-row items-center gap-4 justify-between`}>
                <p className = {"text-slate-500 font-bold text-lg"}>{label}</p>
                <button
                    onClick = {addItem}
                    className = {`flex flex-row gap-1 items-center bg-blue-800 dark:bg-indigo-400 shadow-md border p-1 rounded-md ${isEditMode ? "block" : "hidden"}`}
                >
                    <FontAwesomeIcon className={`text-white`} icon = {faPlus} size = "1x" fixedWidth />
                    <p className={`text-white`}>Add new Synopsis</p>
                </button>
            </div>
            <div className = {`flex flex-col w-full gap-2 mt-4`}>
                {items && items.length > 0 ?
                    items.map((_, index) =>
                        <div className = {`flex flex-row items-center w-full gap-2`} key = {`${index}`}>
                            <textarea
                                className = {`p-2 rounded-md bg-light w-full disabled:bg-gray-100 disabled:dark:bg-gray-300 dark:text-gray-900 ${isEditMode ? "text-gray-800" : ""}`}
                                disabled = {!isEditMode}
                                value = {items[index]}
                                onChange = {(e) => {
                                    const newItems = [ ...items ];

                                    newItems[index] = e.target.value;
                                    updateField(fieldName, newItems);
                                }}
                            />
                            <button
                                className = {`bg-red-400 p-2 rounded-md ${isEditMode ? "block" : "hidden"}`}
                                onClick = {() => {
                                    deleteItem(index);
                                }}
                            >
                                <FontAwesomeIcon icon = {faTrashCan} size = "1x" fixedWidth className={`text-white`} />
                            </button>
                        </div>
                    ) : <div className = {`p-4 ${isEditMode ? "hidden" : "block"}`}>
                        <p className = {`font-bold text-slate-500`}>{`No ${label} Added Yet.`}</p>
                        </div>
                }
            </div>
        </>
    );
};

export default MultiTextareaField;